import TeamLeaderboard from './TeamLeaderboard';
export default TeamLeaderboard;
